import { WebLocale } from '@/enums/web-locale';
import { JWTVLP } from '@/lazy-load-components';
import { PageType } from '@/routing/config';
import { RouteRecordRaw } from 'vue-router';
import { CollectionType } from '@/enums/collection-type';
import { JWTV_LAUNCH_COUNTRIES } from '@/features/jwtv/config';
// export const rentalListLocales = [WebLocale.au, WebLocale.nz, WebLocale.uk, WebLocale.us] as const;
// export type RentalListLocale = (typeof rentalListLocales)[number];

export function makeRentalListRoutes(currentLocale: WebLocale): RouteRecordRaw[] {
	const routes: RouteRecordRaw[] = [];

	if (JWTV_LAUNCH_COUNTRIES.includes(currentLocale)) {
		routes.push(makeJwtvLPRoute(currentLocale as WebLocale));
	}

	return routes;
}

function makeJwtvLPRoute(currentLocale: WebLocale): RouteRecordRaw {
	return {
		name: 'app.jwtv.landing-page',
		path: `/${currentLocale}/justwatch-tv`,
		component: JWTVLP,
		meta: {
			tab: 'watch',
			pageType: PageType.WATCH,
			collectionType: CollectionType.JWTV_WATCH_PAGE,
		},
	};
}
